<template>
  <SogFlexRow>
    <GdvAccessListItemComponent
      v-for="(item) in data"
      :key="item"
      :data="item"
    >
      <SogCardActions>
        <SogCardActionButton
          ref="btnSearch"
          tooltip="bearbeiten"
          mdi-icon="mdi-pencil"
          @click="onEdit(item)"
        />
        <SogCardActionButton
          ref="btnSearch"
          tooltip="Password ändern"
          mdi-icon="mdi-form-textbox-password"
          @click="onChangePin(item)"
        />
      </SogCardActions>
    </GdvAccessListItemComponent>
  </SogFlexRow>
</template>

<script setup lang="ts">
import GdvAccess from "@/shared/model/GdvAccess";
import GdvAccessListItemComponent from "@/modules/Gdv/components/GdvAccessListItemComponent.vue";
import SogFlexRow from "@/shared/ui/SogFlexRow.vue";
import SogCardActions from "@/shared/ui/SogCardActions.vue";
import SogCardActionButton from "@/shared/ui/SogCardActionButton.vue";
interface Props {
  data?:GdvAccess[];
}
//const _data = ref<GdvAccess[]>([])
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const props = withDefaults(defineProps<Props>(), {
      data:undefined
    }
)

async function onEdit(value:GdvAccess) {
  emit('editClicked',value)
}

async function onChangePin(value:GdvAccess) {
  emit('changePinClicked',value)
}

//const emit = defineEmits<{(e:'editClicked',gdvAccess:GdvAccess):void}>();
const emit = defineEmits(['editClicked', 'changePinClicked'])


</script>

<style scoped>

</style>
